import { FC } from 'react';
import { ButtonPrimary } from '@lambdacurry/component-library';
import { GATSBY_NODE_ENV } from '../util/constants';

const NotFoundPage: FC = () => {
  return (
    <main className="prose">
      <title>Not found</title>
      <h1>Page not found</h1>
      <p>
        Sorry{' '}
        <span role="img" aria-label="Pensive emoji">
          😔
        </span>{' '}
        we couldn’t find what you were looking for.
        <br />
        {GATSBY_NODE_ENV === 'development' ? (
          <>
            <br />
            Try creating a page in <code>src/pages/</code>.
            <br />
          </>
        ) : null}
        <br />
        <ButtonPrimary
          as={buttonProps => (
            <a {...buttonProps} href="/">
              Go home
            </a>
          )}
        />
      </p>
    </main>
  );
};

export default NotFoundPage;
